module.exports = __webpack_public_path__ + "static/media/influencer.6e5c51d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/categories/influencer.svg
// module id = 193
// module chunks = 0